import omit from 'lodash/omit';

import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import InPersonIcon from '@mui/icons-material/PinDrop';
import OtherIcon from '@mui/icons-material/HelpOutline';

const getIcon = (touchpoint) => {
  switch (touchpoint) {
    case 'PHONE':
      return PhoneIcon;
    case 'TEXT':
      return ChatIcon; // Assuming text uses the same icon as phone
    case 'EMAIL':
      return EmailIcon;
    case 'IN_PERSON':
      return InPersonIcon;
    case 'INTERNAL':
      return OtherIcon;
    default:
      return OtherIcon;
  }
};

const TouchpointIcon = (props) => {
  const { touchpoint } = props;
  if (!touchpoint) return null;
  const Icon = getIcon(touchpoint);
  return (
    <Icon {...omit(props, 'touchpoint')} />
  );
};

export default TouchpointIcon;